var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { TweenMax } from 'gsap';
import { ActivityManagerTyped as ActivityManager } from 'mixins/ActivityManager';
import AssetLoader from 'mixins/AssetLoader';
import ErrorLogger from 'mixins/ErrorLogger';
import TypingActivityHelper from 'mixins/TypingActivityHelper';
import ActivityTable from '../components/activity/ActivityTable.vue';
import BarGraph from '../components/activity/graphs/BarGraph.vue';
import HtmlRenderer from '../components/activity/HtmlRenderer.vue';
import RedXSolidIcon from '../components/icons/RedXSolidIcon.vue';
import SuccessCheckSolidIcon from '../components/icons/SuccessCheckSolidIcon.vue';
import ActivityStage from '../components/activity/ActivityStage.vue';
import ActivityWrapper from '../components/activity/ActivityWrapper.vue';
import mixins from 'vue-typed-mixins';
import { application, mapState } from '../store/helpers';
const HINT = 'HINT';
const INCORRECT_ATTEMPT = 'INCORRECT_ATTEMPT';
export default mixins(AssetLoader, TypingActivityHelper, ActivityManager(), ErrorLogger).extend({
    components: {
        ActivityStage,
        ActivityTable,
        BarGraph,
        HtmlRenderer,
        RedXSolidIcon,
        SuccessCheckSolidIcon,
        ActivityWrapper
    },
    methods: {
        getActivityState() {
            const { incorrectAttempt, rounds } = this.activityData;
            return {
                incorrectAttempt,
                instructions: Object.assign(Object.assign({}, rounds[0].instructions), { text: rounds[0].instructions.audio.description }),
                rounds
            };
        },
        loadActivity() {
            return __awaiter(this, void 0, void 0, function* () {
                const roundSetup = this.getActivityState();
                this.createRounds(roundSetup);
                const audiosMap = {
                    [HINT]: roundSetup.rounds[0].hint.audio.src,
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttempt.audio.src
                };
                const audioDescriptionsMap = {
                    [HINT]: roundSetup.rounds[0].hint.audio.description,
                    [INCORRECT_ATTEMPT]: roundSetup.incorrectAttempt.audio.description
                };
                this.sfx = yield this.loadAAAudios(audiosMap);
                this.sfxDescriptions = audioDescriptionsMap;
            });
        },
        loadAudios(activityAudios) {
            return __awaiter(this, void 0, void 0, function* () {
                const soundPaths = activityAudios.map(({ audio }) => audio.src);
                this.queueAudio(soundPaths);
                const cache = yield this.downloadAudio();
                return activityAudios.map(({ audio }) => cache.get(audio.src));
            });
        },
        startActivity() {
            this.setupNewRound();
            this.errorLoggerStart();
            this.$nextTick(this.setActivityContainerHeight);
            this.$nextTick(() => {
                TweenMax.to('.activity-stage', 0.5, { opacity: 1 });
            });
        },
        generateSummaryData() {
            var _a, _b;
            let hasError = false;
            const summaryData = (_b = (_a = this.currentRound) === null || _a === void 0 ? void 0 : _a.chart) === null || _b === void 0 ? void 0 : _b.data.reduce((agg, key) => {
                if (!this.currentGraphData[key.label] ||
                    this.currentGraphData[key.label].value !== key.value) {
                    hasError = true;
                }
                agg[key.label] = {
                    correctAnswer: key.value,
                    currentAnswer: this.currentGraphData[key.label]
                        ? this.currentGraphData[key.label].value
                        : 0,
                    label: key.label
                };
                return agg;
            }, {});
            return {
                data: summaryData,
                hasError
            };
        },
        handleActivityError() {
            this.showErrors = true;
            this.showHints = false;
            if (this.numberOfAttempts[0] === 1)
                this.playAudio(INCORRECT_ATTEMPT);
            TweenMax.delayedCall(1, () => {
                this.showErrors = false;
                if (this.numberOfAttempts[0] > 1) {
                    this.showHints = true;
                    this.promptScreenReaderHintAlert();
                    this.playAudio(HINT);
                }
            });
        },
        handleActivitySuccess() {
            this.isComplete = true;
            this.showHints = false;
            this.rerenderScreenReaderAlert('Correct');
            TweenMax.delayedCall(2, () => {
                this.processEndOfActivity();
            });
        },
        handleOnActivitySubmit() {
            if (this.isComplete) {
                return;
            }
            const { data, hasError } = this.generateSummaryData();
            if (data)
                this.graphDataSummary = data;
            this.incrementNumberOfAttempts();
            if (hasError) {
                this.handleActivityError();
            }
            else {
                this.handleActivitySuccess();
            }
        },
        handleOnGraphDataChange(data) {
            this.currentGraphData = data;
        },
        promptScreenReaderHintAlert() {
            Object.keys(this.graphDataSummary).forEach(yAxisItem => {
                var _a;
                this.rerenderScreenReaderAlert(`The correct ${(_a = this.currentRound.chart) === null || _a === void 0 ? void 0 : _a.xAxis.label.toLowerCase()} for ${yAxisItem} is ${this.graphDataSummary[yAxisItem].correctAnswer}.`);
            });
        }
    },
    data() {
        return {
            activityName: 'GraphIt',
            currentGraphData: {},
            graphDataSummary: {},
            isComplete: false,
            showErrors: false,
            showHints: false
        };
    },
    computed: Object.assign(Object.assign({}, mapState(application, ['device'])), { isTablet() {
            return this.device.isMobile;
        } })
});
